import { useEffect, useState } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

import { protectedResources } from "../authConfig";

import { Box } from "@metrea-ui/v2";
import { PageHeader } from "../components/SiteLayout/Header";
import { PageFooter } from "../components/SiteLayout/Footer";
// import { ProfileData } from "../components/ProfileData";

import { callApiWithToken } from "../utils/authUtils";
import { debugLog, errorLog } from "../utils/debugUtils";

const ProfileContent = () => {
	const { instance, accounts, inProgress } = useMsal();
	const account = useAccount(accounts[0] || {});
	const [graphData, setGraphData] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			let token;
			let graphInfo;
			debugLog(2, "[Profile][FLOW] fetchProfileData started", {
				instance: instance,
				account: account,
				inProgress: inProgress,
				graphData: graphData,
			});

			if (!graphData) {
				try {
					token = await instance.acquireTokenSilent({
						scopes: protectedResources.graphMe.scopes,
						account: account,
					});
					debugLog(3, "[Profile][STATE] acquireTokenSilent success", {
						token: token,
					});

					graphInfo = await callApiWithToken(
						token.accessToken,
						protectedResources.graphMe.endpoint
					);
					setGraphData(graphInfo);
				} catch (error) {
					errorLog(2, "[Profile][FLOW] fetchProfileData failed", {
						error: error,
					});

					if (error instanceof InteractionRequiredAuthError) {
						try {
							token = await instance.acquireTokenPopup({
								scopes: protectedResources.graphMe.scopes,
								account: account,
							});

							graphInfo = await callApiWithToken(
								token.accessToken,
								protectedResources.graphMe.endpoint
							);
							setGraphData(graphInfo);
						} catch (error) {
							errorLog(2, "[Profile][FLOW] acquireTokenPopup failed", { error: error });
							console.log(error);
						}
					}
				}
			}
		};

		fetchData();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [account, inProgress, instance]);

	return <>{graphData ? <ProfileData graphData={graphData} /> : null}</>;
};

export const ProfileData = (props) => {
	const tableRows = Object.entries(props.graphData).map((entry, index) => {
		return (
			<tr key={index}>
				<td>
					<b>{entry[0]}: </b>
				</td>
				<td>{entry[1]}</td>
			</tr>
		);
	});

	return (
		<>
			<PageHeader pageTitle="AD Profile" />
			<Box className="pageContent">
				<div className="data-area-div">
					<p>
						Calling <strong>Microsoft Graph API</strong>...
					</p>
					<ul>
						<li>
							<strong>resource:</strong> <mark>User</mark> object
						</li>
						<li>
							<strong>endpoint:</strong> <mark>https://graph.microsoft.com/v1.0/me</mark>
						</li>
						<li>
							<strong>scope:</strong> <mark>user.read</mark>
						</li>
					</ul>
					<p>
						Contents of the <strong>response</strong> is below:
					</p>
					<br />
				</div>
				<div className="data-area-div">
					<table>
						<thead></thead>
						<tbody>{tableRows}</tbody>
					</table>
				</div>
				<PageFooter />
			</Box>
		</>
	);
};

export const Profile = () => {
	const navigate = useNavigate();

	return (
		<>
			<ProfileContent />
			<br />
			<center>
				<p>
					<button className="btn btn-secondary" onClick={() => navigate("/")}>
						Home
					</button>
				</p>
			</center>
		</>
	);
};
